import { Modal, Button } from "react-bootstrap";

const DeleteDealModal = ({ show, handleClose, onDelete }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Deal</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>Are you sure you want to delete this deal?</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteDealModal;